import github from '../../assets/image/github.svg'
import linkedIn from '../../assets/image/linkedin.svg'
import telegram from '../../assets/image/telegram.svg'
import email from '../../assets/image/email.svg'
import codewars from '../../assets/image/codewars-blue.png'

export const contactsData = [
    {
        id: '1',
        link: 'https://github.com/Zouker',
        logo: `${github}`,
    },
    {
        id: '2',
        link: 'https://www.linkedin.com/in/denis-shubin/',
        logo: `${linkedIn}`,
    },
    {
        id: '3',
        link: 'https://www.codewars.com/users/Zouker',
        logo: `${codewars}`,
    },
    {
        id: '4',
        link: 'https://t.me/Denis_ACK',
        logo: `${telegram}`,
    },
    {
        id: '5',
        link: 'mailto:denis.shubin@gmail.com',
        logo: `${email}`,
    },
]